import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App.js'
import './app.css'
import { requestPersistentStorage } from './db/dexie.js'
import { initPwa } from './pwa/install.js'
import { initTheme } from './theme.js'

// The inline script in index.html has already applied whatever localStorage
// held; this only catches an install that stored its choice before that script
// existed, and costs one Dexie read.
void initTheme()

const container = document.getElementById('root')
if (!container) throw new Error('Missing #root')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Installed web apps are granted persistence heuristically; without it a long
// gap between uses can evict the offline diary.
void requestPersistentStorage()

// Registers the service worker. Without this the app is not installable at all:
// Chrome refuses to offer a home-screen install to a site with no worker.
initPwa()
